export type CalendarEventsItemDto = {
  id: string;
  type: CalendarEventType;
  text?: string;
  dateOn: Date;
  dateIn?: Date;
  dateOut?: Date;
  value: number;
};

export type CalendarEventsListDto = CalendarEventsItemDto[];

export enum DocumentType {
  Reservation, Accommodation
};

export enum   CalendarEventType {
  Reservation,
  Accommodation,
  HouseUse
};

export type CalendarApartmentDocumentResponseDto = {
  documentId: string;
  eventType: CalendarEventType;
  documentType: DocumentType;
  revenue: number;
  monthRevenue: number;
  checkInDate: Date;
  checkOutDate: Date;
};

export type CalendarApartmentResponseDto = {
  apartmentId: string;
  apartmentName?: string;
  totalAmount: number;
  monthTotalAmount: number;
  documents?: CalendarApartmentDocumentResponseDto[];
};

export type CalendarResponseDto = {
  apartments?: CalendarApartmentResponseDto[];
};

export type BookedApartmentListItemDto = {
    id: string;
    name?: string;
  };

  export type BookedApartmentListItemDtoListResponseDto = {
    items?: BookedApartmentListItemDto[];
    totalCount: number;
  };